import { gql } from '@apollo/client';

export const NON_WORKING_DAYS_QUERY = gql`
  query nonWorkingDays {
    nonWorkingDays {
      nonWorkingDayId
      nonWorkingDayDate
      description
      workingSiteId
      workingDay
      validInAllContexts
      contexts
    }
  }
`;

export const NON_WORKING_DAY_CONTEXTS_QUERY = gql`
  query nonWorkingDayContexts {
    nonWorkingDayContexts {
      dictionaryItemId
      dictionaryItemName
    }
  }
`;

export const SITES_QUERY = gql`
  query sites {
    sites {
      siteId
      siteName
    }
  }
`;
